import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useTag from '@hooks/useTag'

import type { TagModel } from '@models/types'

const TagListItem = (props: { tag: TagModel }) => {
  const { tag, tag: { global, id, title } } = props

  const tagPayload = useTag(tag)
  const {
    brand,
    callbacks: { createOrEditTag },
  } = tagPayload

  const currentUserPayload = useCurrentUser()
  const { isBrandUser } = currentUserPayload

  const isDisabled = isBrandUser && global

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2322
      disableHover={isDisabled}
      onClick={!isDisabled ? () => createOrEditTag() : undefined}
      secondaryText={global ? 'Global' : brand?.title}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        # {id}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default TagListItem
